import {checkValid} from "../../../globalModels/functions/ModelsValidate";
import {HSCodeItemGroup} from "@/components/modules/HSCodesModule/models/HSCodeItemGroup";
// let _ = require('lodash');

export function HSCode() {

  this.checkValid = checkValid

  this.data = {

    /***
     * Pseudo Required Fields start
     */

    user: {},
    userId: '',
    id: '',
    type: '',
    sourceOrderId: '',

    /*** ***/

    category: '',
    name: '',
    material: '',
    code: '',
    codeUSA: '',
    countryGroupId: 0,
    dutyPercent: '0',

    HSGroups: [new HSCodeItemGroup()],
}

  this.validation = {
    category: false,
    name: false,
    material: false,
    code: false,
    codeUSA: false,
    dutyPercent: false,
  }

  this.validationTranslate = {
    category: '',
    name: '',
    material: '',
    code: '',
    codeUSA: '',
    dutyPercent: '',
  }

  this.validationTxt = {
    category: false,
    name: false,
    material: false,
    code: false,
    codeUSA: false,
    dutyPercent: false,
  }

}


/*****************   SETTERS   ******************/

/***
 * Pseudo Required Fields start
 */

HSCode.prototype.setUser = function (val) {
  this.data.user = val
}

HSCode.prototype.setUserId = function (val) {
  this.data.userId = val
}

HSCode.prototype.setId = function (val) {
  this.data.id = val
}

HSCode.prototype.setType = function (val) {
  this.data.type = val
}

HSCode.prototype.setSourceOrderId = function (val) {
  this.data.sourceOrderId = val
}

/*** **/


HSCode.prototype.setCategory = function (val) {
  this.data.category = val
  this.setName('')
  this.setMaterial('')
}

HSCode.prototype.setName = function (val) {
  this.setMaterial('')
  this.data.name = val
}

HSCode.prototype.setMaterial = function (val) {
  this.data.material = val
}

HSCode.prototype.setCode = function (val) {
  this.data.code = val
}

HSCode.prototype.setCodeUSA = function (val) {
  this.data.codeUSA = val
}

HSCode.prototype.setCountryGroupId = function (val) {
  this.data.countryGroupId = val
}

HSCode.prototype.setDutyPercent = function (val) {
  this.data.dutyPercent = val
}

HSCode.prototype.setHSCodeItem = function (val) {
  this.setCategory(val.proform_category)
  this.setName({proform_value: val.proform_name})
  this.setMaterial({proform_value: val.proform_material})
  this.setCode(val.code)
  this.setCountryGroupId(val.country_group_id)
  this.setDutyPercent(val.duty_percent)
}

HSCode.prototype.removeGroup = function(index) {
  this.data.HSGroups.splice(index, 1)
}

HSCode.prototype.setHSCodeItemGroup = function (val) {
  this.setCategory(val.proformCategory)
  this.setName({proform_value: val.proformName})

  this.data.HSGroups = []

  val.groups.forEach(group => {
    let newGroup = new HSCodeItemGroup()
    newGroup.setHSCodeItemGroup(group)
    this.data.HSGroups.push(newGroup)

    // groups.hs_codes.forEach(code => {
    //
    //   if(groups.country_group_id === 12) {
    //     this.data.EUTypeGroup.push(group)
    //   }
    //
    //   if(groups.country_group_id === 13) {
    //     this.data.USATypeGroup.push(group)
    //   }
    // })
  })
  console.log(val);
}




/*****************   GETTERS   ******************/

/***
 * Pseudo Required Fields start
 */

HSCode.prototype.getUser = function () {
  return this.data.user
}

HSCode.prototype.getUserId = function () {
  return this.data.userId
}

HSCode.prototype.getId = function () {
  return this.data.id
}

HSCode.prototype.getType = function () {
  return this.data.type
}

HSCode.prototype.getSourceOrderId = function () {
  return this.data.sourceOrderId
}

/*** ***/

HSCode.prototype.getCategory = function () {
  return this.data.category
}

HSCode.prototype.getName = function () {
  return this.data.name
}

HSCode.prototype.getMaterial = function () {
  return this.data.material
}

HSCode.prototype.getCode = function () {
  return this.data.code
}

HSCode.prototype.getCodeUSA = function () {
  return this.data.codeUSA
}

HSCode.prototype.getDutyPercent = function () {
  return this.data.dutyPercent
}

/*******************   FUNCTIONS   *************/



/******************  VALIDATIONS  *****************/


HSCode.prototype.firstValidation = function (
  {
    codeUSA = false
  }
) {

  let data = this.data

  let validationItems = {
    category: data.category,
    name: data.name,
    material: data.material,
    code: data.code,
    codeUSA: data.codeUSA,
    dutyPercent: data.dutyPercent,
  }

  let validationOptions = {
    category: {type: ['empty']},
    name: {type: ['empty']},
    material: {type: ['empty']},
    code: {type: ['empty']},
    codeUSA: {type: codeUSA ? ['empty'] : []},
    dutyPercent: {type: ['empty']},
  }

  return (this.checkValid(validationItems, validationOptions))

}

HSCode.prototype.hsGroupValidation = function () {

  let data = this.data

  let validationItems = {
    category: data.category,
    name: data.name,
  }

  let validationOptions = {
    category: {type: ['empty']},
    name: {type: ['empty']},
  }

  let valid = true

  data.HSGroups.forEach(i => {
    if(!i.firstValidation()) valid = false
  })

  return (this.checkValid(validationItems, validationOptions) && valid)

}

/******************  PREPARE DATA  *****************/


HSCode.prototype.prepareData = function(edit = false) {

  let data = {
    'proform_category_id' : this.data.category.id,
    'proform_name_id' : this.data.name["proform_value"].id,
    'duty_percent' : this.data.dutyPercent,
  }

  if(!edit) {
    data['code_europe'] = this.data.code
    data['code_usa'] = this.data.codeUSA
    data['proform_material_ids'] = this.data.material.map(item => {return item["proform_value"].id})
  } else {
    data['proform_material_id'] = this.data.material["proform_value"].id
    data['code'] = this.data.code
  }

  return data
}


HSCode.prototype.prepareDataHsGroup = function(edit = false) {
  console.log(edit);

  let data = {
    'proform_category_id' : this.data.category.id,
    'proform_name_id' : this.data.name["proform_value"].id,
    "groups": this.data.HSGroups.map(i => {
      return i.prepareData()
    }),
  }

  return data
}